interface AppConfig {
  env: string;
  apiBaseUrl: string;
}

const config: AppConfig = {
  env: import.meta.env.VITE_ENV || 'local',
  // When VITE_API_BASE_URL is unset, derive the API host from whatever host the
  // app is being viewed on (localhost, victors-macbook-pro, victors-mac-mini, …)
  // so the SPA reaches the backend on the SAME machine on port 8003.
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    `${window.location.protocol}//${window.location.hostname}:8003`,
};

export default config;
